/**
 * GEN-E-99-33 — the modules (platform applications) that scale themselves down on a small viewport, the way a
 * 75–80% browser zoom would. An entry is an ApplicationModel `id` as the app switcher knows it (`xatbot-pro`,
 * `gmt`, `filing-manager`, …); `'*'` scales every application — the whole ITP.
 *
 * Enabling a module is one id here plus the audit in ITPKV `1. Framework/Viewport-Scale.md`.
 */
// GEN-E-99-67 — the whole ITP. The module-by-module list it replaces, each audited on its own:
// export const VIEWPORT_SCALED_APPLICATIONS: readonly string[] = [
//   'xatbot-pro',
//   'itrce', // GEN-E-99-53 — International Tax Research
//   'gmt', // GEN-E-99-59 — Global Minimum Tax
//   'filing-manager', // GEN-E-99-60 — Filing Manager
//   'filing-manager-publisher', // GEN-E-99-61 — Filing Manager Publisher
//   'audit-tracker', // GEN-E-99-62 — Audit Tracker
//   'cbc-reporting-calculator', // GEN-E-99-63 — CbC Compliance & Reporting
//   'change-reports-tracker', // GEN-E-99-64 — Change Reports
//   'due-date-tracker', // GEN-E-99-65 — Due Date Tracker
//   'entity-tracker', // GEN-E-99-66 — Entity Tracker
// ];
export const VIEWPORT_SCALED_APPLICATIONS: readonly string[] = ['*']; // for all module


/**
 * GEN-E-105-01 — the runtime switch. The viewport scale is OFF unless the deployment's
 * `assets/environments/environment.json` sets `dynamicsettings.ViewportScale` to `true`, so it can be turned on or
 * off per environment without a rebuild. Off: no base scale (density still applies around 1, ADR 0154).
 */
export const VIEWPORT_SCALE_SETTING = 'ViewportScale';

/**
 * GEN-E-105-01 — the marker the index.html pre-boot reads. The switch lives in environment.json, which loads after
 * first paint, so the pre-boot only scales when the service last saw the switch on in this browser ('1'). The
 * service writes it on every boot; switching off clears it, so the next load paints unscaled.
 */
export const PREBOOT_VIEWPORT_SCALE_KEY = 'itp.viewportScale';

/** Whether a `dynamicsettings` object turns the viewport scale on (`true` or `"true"`; anything else is off). */
export function viewportScaleSwitchOn(settings: Record<string, unknown> | null | undefined): boolean {
  const value = settings?.[VIEWPORT_SCALE_SETTING];
  return value === true || value === 'true';
}
